export default __webpack_public_path__ + "static/media/goncalosilva.ae6e35ba.jpg";